var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/externalsignal",
    transform: "translate(-2.000000, -4.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76,16.24 C6.67,15.16 6,13.66 6,12 C6,10.34 6.67,8.84 7.76,7.76 L9.18,9.18 C8.45,9.9 8,10.9 8,12 C8,13.1 8.45,14.1 9.17,14.83 L7.76,16.24 Z M16.24,16.24 C17.33,15.16 18,13.66 18,12 C18,10.34 17.33,8.84 16.24,7.76 L14.82,9.18 C15.55,9.9 16,10.9 16,12 C16,13.1 15.55,14.1 14.83,14.83 L16.24,16.24 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z M20,12 C20,14.21 19.1,16.21 17.65,17.65 L19.07,19.07 C20.88,17.26 22,14.76 22,12 C22,9.24 20.88,6.74 19.07,4.93 L17.65,6.35 C19.1,7.79 20,9.79 20,12 Z M6.35,6.35 L4.93,4.93 C3.12,6.74 2,9.24 2,12 C2,14.76 3.12,17.26 4.93,19.07 L6.35,17.65 C4.9,16.21 4,14.21 4,12 C4,9.79 4.9,7.79 6.35,6.35 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.ff62ef168f71aee12bab0bc0c82d4735.svg";
export { ForwardRef as ReactComponent };